module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'customers'
      }
    }
  }, [_vm._v("\n            Customers\n          ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Add Customer")])])])]), _vm._v(" "), _c('section', {
    staticClass: "content customers-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('el-form', {
    ref: "customer",
    attrs: {
      "model": _vm.customer,
      "rules": _vm.rules,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.customer.name),
      callback: function($$v) {
        _vm.$set(_vm.customer, "name", $$v)
      },
      expression: "customer.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('customer')
      }
    }
  }, [_vm._v("Create")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm('customer')
      }
    }
  }, [_vm._v("Reset")])], 1)], 1), _vm._v(" "), _c('hr')], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6d0c390d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/customers/Add.vue
// module id = 1160
// module chunks = 2